// extracted by mini-css-extract-plugin
export default {"badge":"PmkAOCbFkaQXGW36MpHi","round":"A6LGKXxJAlZnuMSTfXd8","default":"pond89195cqR5OOzpRAW","defaultText":"_Z9icTC12wuKAIVws8xf","largeText":"zcU4DdYpkn6oZa_mQUQS"};